import { render, staticRenderFns } from "./OrgSelectionList.vue?vue&type=template&id=4f963c8a&"
import script from "./OrgSelectionList.vue?vue&type=script&lang=js&"
export * from "./OrgSelectionList.vue?vue&type=script&lang=js&"
import style0 from "./OrgSelectionList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports